import React from "react";
import { Redirect } from "react-router-dom";
import { useAuth } from "../context/auth";

export default ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Redirect to="/login" />;
};
